<p-card styleClass="flex flex-col w-full h-full p-4">
    <ng-template pTemplate="header">
        <div class="flex justify-between items-center">
            <h2 class="text-xl font-semibold">{{ setTitle() }}</h2>
            <app-icon-button 
                *ngIf="showAddActivityButton"
                [icon]="icons.solid.faCirclePlus" 
                textSize="text-lg" 
                [pTooltip]="'Create an Activity'" 
                [showDelay]="500"
                (click)="addActivity()">
            </app-icon-button>
        </div>
    </ng-template>

    <div *ngIf="loading" class="flex justify-center items-center py-4">
        <p class="text-gray-600">Loading activities...</p>
    </div>

    <div *ngIf="error" class="flex justify-center items-center py-4">
        <p class="text-red-500">{{ error }}</p>
    </div>

    <div *ngIf="!loading && !error && activities().length === 0" class="flex justify-center items-center py-4">
        <p class="text-gray-600">{{ setNoActivitiesMessage() }}</p>
    </div>

    <div class="flex flex-col gap-2" [ngClass]="maxHeight ? 'mini-scrollbar overflow-y-auto pr-3' : ''" [ngStyle]="{'max-height': maxHeight + 'px'}">
        <div *ngFor="let activity of activities(); let last = last">
          <app-note-display *ngIf="activity.completed === 0" 
            [note]="activity" 
            dateField="dateScheduled"
            [groupName]="`${activity.groupName || 'Group'} (${activity.custId})`">
          </app-note-display>
          <p-divider *ngIf="!last"></p-divider>
        </div>
      </div>
</p-card> 